export const headers = [
  { name: 'Nome', field: 'name', sortable: true },
  { name: 'Email', field: 'email', sortable: false },
  { name: 'Grupo de usuário', field: 'role', sortable: false, custom: true },
  { name: 'Ações', field: 'actions', sortable: false }
]
